import { render } from "./BarcodeInfo.vue?vue&type=template&id=3b13b008&scoped=true"
import script from "./BarcodeInfo.vue?vue&type=script&lang=js"
export * from "./BarcodeInfo.vue?vue&type=script&lang=js"

import "./BarcodeInfo.vue?vue&type=style&index=0&id=3b13b008&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3b13b008"

export default script